export const TAKEY_FORM_SUBMISSION = 'TAKEY_FORM_SUBMISSION';
export const JOIN_US = 'JOIN_US';
export const DRIVE_WITH_US = 'DRIVE_WITH_US';
export const CONTACT_US = 'CONTACT_US';
export const TAKEY_EMAIL_SUCCESS = 'TAKEY_EMAIL_SUCCESS';
export const TAKEY_EMAIL_FAIL = 'TAKEY_EMAIL_FAIL';